<template>
  <nav class="col-sm-8">
    <ul>
      <template v-for="item in menuItemList">
        <li :key="item.name">
          <router-link
            v-if="item.type==='router'"
            :to="{ name: item.redirect, params: item.params }"
            v-text="item.name"
          />
          <a
            v-else-if="item.type==='external'"
            :href="item.url"
            v-text="item.name"
            target="_blank"
          />
          <a
            v-else
            href="javascript:void(0)"
            v-text="item.name"
            @click="item.type==='function' && item.doFunction()"
          />
        </li>
        {{ '&nbsp;' }}
      </template>
    </ul>
  </nav>
</template>
<script>
import { isEmpty, remove } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'Menu',
  data() {
    return {
      menuItemList: []
    }
  },
  computed: {
    ...mapState({
      user: 'user'
    }),
    isLogged() {
      return this.user.isLoggedIn
    }
  },
  watch: {
    $route: {
      handler() {
        this.getMenuInfo()
        $('body').removeClass('open_menu')
      },
      immediate: true
    },
    menuItemList: {
      handler(val) {
        this.$emit('onCheckMenu', !isEmpty(val))
      },
      immediate: true
    },
    isLogged() {
      this.getMenuInfo()
    }
  },
  methods: {
    isEmpty,
    getMenuInfo() {
      let menuConst = [
        {
          name: this.$t('route.home'),
          key: 'home',
          type: 'router',
          redirect: 'home'
        },
        {
          name: this.$t('route.whoWeAre'),
          key: 'whoWeAre',
          type: 'router',
          redirect: 'whoWeAre'
        },
        {
          name: this.$t('route.faq'),
          key: 'faq',
          type: 'router',
          redirect: 'faq'
        },
        {
          name: this.isLogged ? this.$t('route.logout') : this.$t('route.login'),
          key: this.isLogged ? 'logout' : 'login',
          type: this.isLogged ? 'function' : 'router',
          doFunction: () => {
            this.$store.dispatch('logout')
          },
          redirect: 'login'
        }
      ]
      if (this.$route.name === 'home') {
        menuConst = menuConst.slice(0, -1)
      }
      if (this.isLogged) {
        menuConst.splice(
          2,
          0,
          ...[
            {
              name: this.$t('route.library'),
              key: 'library',
              type: 'router',
              redirect: 'videoLibrary'
            },
            {
              name: this.$t('route.findACounselor'),
              key: 'findACounselor',
              type: 'router',
              redirect: 'findACounselor'
            },
            {
              name: this.$t('route.myChurch'),
              key: 'myChurch',
              type: 'router',
              redirect: 'myChurchProfile'
            }
          ]
        )
        remove(menuConst, route => route.key === 'faq')
      } else {
        menuConst.splice(2, 0, {
          name: this.$t('route.pricing'),
          key: 'pricing',
          type: 'router',
          redirect: 'pricing'
        })
      }
      this.menuItemList = menuConst
    }
  },
  mounted() {
    // if (!isEmpty(this.menuItemList)) {
    //   $('.nav_icon').click(function() {
    //     $('body').toggleClass('open_menu')
    //   })
    // }
  }
}
</script>
